// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import NormalGameManager from "../../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class OrchardSelectLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeList: cc.Node = null;

    @property(cc.Node)
    nodeCollect: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    private csvInfos = null;

    start () {
        O1HD.on(MessageEventKind.EventName.REFRESH_ORCHARD_COLLECT_STATE, this.refreshCollectState, this);
        O1HD.getModules().uiControlModule.hideLoading();
        this.initLayer();

        this.refreshCollectState();
    }

    initLayer() {
        this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.ORCHARD);
        if (!this.csvInfos) {
            console.error("ORCHARD: csvInfos is null");
            return;
        }

        let children = this.nodeList.children;
        children.forEach((node, index) => {
            node.active = false;
        });

        let title = this.csvInfos.title;
        let i = 0;
        for (let k in this.csvInfos) {
            if (k == 'title' || k == '' || k.trim() == '') {
                continue;
            }
            let info = this.csvInfos[k];

            let nodeItem = children[i];
            if (!nodeItem) {
                continue;
            }
            nodeItem.active = true;

            let nodeTouch = nodeItem.getChildByName('nodeTouch').getComponent(cc.Button);
            nodeTouch.clickEvents[0].customEventData = k;

            let labelName = nodeItem.getChildByName('labelName').getComponent(cc.Label);
            labelName.string = info[title.name];
            
            let price = utilsModel.csvNumberParse(info[title.price]);
            let labelPrice = nodeItem.getChildByName('labelPrice').getComponent(cc.Label);
            labelPrice.string = data_control.getNumberFormat(price);

            i ++;
        }
    }

    refreshCollectState() {

        let colletConfig = GeneralKind.OrchrdCollect;
        this.nodeCollect.children.forEach((v, i)=> {
            let item = colletConfig[i];
            let goods = NormalGameManager._instance.getOneGood(item);
            v.active = true;
            if (!goods || goods.num <= 0)  {
                v.active = false;
            }
        });
    }


    onClickEnter(event: cc.Event.EventTouch, data) {
        let nodeItem = event.getCurrentTarget();
        let polygon = nodeItem.getComponent(cc.PolygonCollider);

        let touchPos = nodeItem.convertToNodeSpaceAR(event.getLocation());
        touchPos.x -= polygon.offset.x;
        touchPos.y -= polygon.offset.y;

        if (cc.Intersection.pointInPolygon(touchPos, polygon.points)) {
            nodeItem._touchListener.setSwallowTouches(true);
        } else {
            nodeItem._touchListener.setSwallowTouches(false);
            return;
        }
        
        let title = this.csvInfos.title;
        let info = this.csvInfos[data];
        let price = utilsModel.csvNumberParse(info[title.price]);
        let gold = O1HD.getServices().userSrv.getCoins();
        if (gold < price) {
            O1HD.getModules().uiControlModule.showMessageBox('金额不足');
            NormalGameManager._instance.openBankPage();
            return;
        }

        O1HD.getServices().userSrv.setCoins(-price, true);

        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayer(
            'prefab/OrchardOperateLayer'
            , BUNDLE_SMALL_NAME.orchardBundle
            , this.node
            ,{
                id: data
            }
            , null
            , null
            , false
        );
    }

    onClickCollect() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.getModules().uiControlModule.showMessageBox('似乎有什么神秘功能');
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
